
import idMessages from '../locales/id_ID';

const IdLang = {
  messages: {
    ...idMessages,
  },
  locale: 'id-ID',
 
};
export default IdLang;
